// import React from 'react';
// import './footer.css';
// import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

// function Footer() {
//   return (
//     <footer className="footer">
//       <div className="footer-container">
//         <div className="footer-column logo-column">
//           <h2>Asian Polytechnic Campus</h2>
//           <p>Empowering future professionals through excellence in education and training.</p>
//         </div>

//         <div className="footer-column">
//           <h3>Quick Links</h3>
//           <ul>
//             <li><a href="/about">About Us</a></li>
//             <li><a href="/programs">Programs</a></li>
//             <li><a href="/admissions">Admissions</a></li>
//             <li><a href="/contact">Contact</a></li>
//           </ul>
//         </div>

//         <div className="footer-column">
//           <h3>Contact Us</h3>
//           <p><FaMapMarkerAlt /> 123 Education Lane, Colombo, Sri Lanka</p>
//           <p><FaPhone /> +94 11 234 5678</p>
//           <p><FaEnvelope /> info@asianpolytechnic.lk</p>
//         </div>

//         <div className="footer-column social-column">
//           <h3>Follow Us</h3>
//           <div className="social-icons">
//             <a href="#"><FaFacebookF /></a>
//             <a href="#"><FaInstagram /></a>
//             <a href="#"><FaLinkedinIn /></a>
//           </div>
//         </div>
//       </div>
//       <div className="footer-bottom">
//         <p>&copy; {new Date().getFullYear()} Asian Polytechnic Campus. All Rights Reserved.</p>
//       </div>
//     </footer>
//   );
// }

// export default Footer;




import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../FirebaseComp/firebase'; // Adjust path based on your structure

function Footer() {


    const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, 'subscribers'), { email });
      setMessage('You have successfully subscribed!');
      setEmail('');
    } catch (error) {
      console.error('Error subscribing:', error);
      setMessage('Failed to subscribe. Please try again.');
    }
  };




  return (
    <footer className="apc-footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          {/* University Info */}
          <div className="footer-section footer-about">
            <div className="footer-logo">
              <img src="/logo192.png" alt="Asian Polytechnic Campus" />
              <div className="logo-text">
                <span className="logo-main-footer">ASIAN POLYTECHNIC</span>
                <span className="logo-sub-footer">CAMPUS</span>
              </div>
            </div>
            <p className="footer-description">
              Asian Polytechnic Campus is a premier institution dedicated to excellence in technical education, 
              fostering innovation, and preparing students for global challenges.
            </p>
            <div className="footer-social">
              
         <a 
            href="https://www.facebook.com/profile.php?id=61576040872014" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <i className="fab fa-facebook-f"></i>
          </a>


              <a href="https://twitter.com" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="https://linkedin.com" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://youtube.com" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
              <a href="https://instagram.com" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/aboutus">About APC</Link></li>
              <li><Link to="/programs">Academic Programs</Link></li>
              <li><Link to="/admission">Admissions</Link></li>
              <li><Link to="/research">Research</Link></li>
              <li><Link to="/activities">Campus Life</Link></li>
              <li><Link to="/news">News & Events</Link></li>
            </ul>
          </div>

          {/* Academic Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Academics</h3>
            <ul className="footer-links">
              <li><Link to="/engineering">School of Engineering</Link></li>
              <li><Link to="/technology">School of Technology</Link></li>
              <li><Link to="/computer-science">Computer Science</Link></li>
              <li><Link to="/business">Business & Management</Link></li>
              <li><Link to="/applied-sciences">Applied Sciences</Link></li>
              <li><Link to="/graduate-studies">Graduate Studies</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section footer-contact">
            <h3 className="footer-heading">Contact Us</h3>
            <ul className="footer-contact-info">
              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>932, Maradana Road, Colombo 08, Sri Lanka</span>
              </li>
              <li>
                <i className="fas fa-phone-alt"></i>
                <span>+94 112 682 277</span>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <span>info@apc.com</span>
              </li>
              <li>
                <i className="fas fa-clock"></i>
                <span>Monday - Friday: 8:30AM - 5:30PM</span>
              </li>
            </ul>


          <div className="footer-newsletter">
                <h4>Subscribe to Newsletter</h4>
                <form className="newsletter-form" onSubmit={handleSubscribe}>
                  <input
                    type="email"
                    placeholder="Your email address"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button type="submit">Subscribe</button>
                </form>
                {message && <p style={{ marginTop: '10px', color: 'white' }}>{message}</p>}
          </div>


          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-copyright">
            &copy; {new Date().getFullYear()} Asian Polytechnic Campus. All Rights Reserved.
          </div>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button className="footer-back-to-top" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
        <i className="fas fa-arrow-up"></i>
      </button>
    </footer>
  );
}

export default Footer;